import React from 'react';
import { useNavigate } from 'react-router-dom';

const RegistrationInfo = () => {
  const navigate = useNavigate();

  const handleRegisterClick = (e) => {
    e.preventDefault(); // Prevent the default browser behavior
    navigate('/conference-registration/payment'); // Navigate programmatically
  };

  return (
    <div className="bg-white p-8 rounded-lg max-w-5xl mx-auto">
      <h2 className="text-2xl font-medium mb-4">Registration Information</h2>
      <p className="text-gray-700 mb-4">
        Students are advised to first submit their abstract and register post acceptance. However, they are encouraged to{' '}
        <em className="italic">submit the abstract well in advance to get timely review and acceptance to avail early-bird registration offer.</em>
      </p>
      <p className="text-gray-700 mb-6">
        However, they may also first register and then submit the abstract. However, prior registration does not guarantee the acceptance of abstract.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 p-2 font-semibold" rowSpan="2">Category</th>
              <th className="border border-gray-300 p-2 font-semibold" colSpan="2">
                Early Bird Registration* <br />
                <span className="text-sm font-normal">[Till 31<sup>st</sup> July 2025]</span>
              </th>
              <th className="border border-gray-300 p-2 font-semibold" colSpan="2">
                Late Registration* <br />
                <span className="text-sm font-normal">[Till 30<sup>th</sup> September 2025]</span>
              </th>
              <th className="border border-gray-300 p-2 font-semibold" rowSpan="2">Click here for payment</th>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2 font-semibold">Member</th>
              <th className="border border-gray-300 p-2 font-semibold">Non-Member</th>
              <th className="border border-gray-300 p-2 font-semibold">Member</th>
              <th className="border border-gray-300 p-2 font-semibold">Non-Member</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2">Students</td>
              <td className="border border-gray-300 p-2">₹ 2500</td>
              <td className="border border-gray-300 p-2">₹ 3500</td>
              <td className="border border-gray-300 p-2">₹ 3500</td>
              <td className="border border-gray-300 p-2">₹ 4500</td>
              <td rowSpan="7" className="border border-gray-300 p-2 text-center align-middle">
                <button
                  onClick={handleRegisterClick}
                  className="bg-[#4f46e5] text-white px-4 py-2 rounded hover:bg-[#6a63e9]"
                >
                  Pay Now
                </button>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Postdoc/Young Scientist</td>
              <td className="border border-gray-300 p-2">₹ 4000</td>
              <td className="border border-gray-300 p-2">₹ 5000</td>
              <td className="border border-gray-300 p-2">₹ 5000</td>
              <td className="border border-gray-300 p-2">₹ 6000</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Faculty/Scientist</td>
              <td className="border border-gray-300 p-2">₹ 7000</td>
              <td className="border border-gray-300 p-2">₹ 8000</td>
              <td className="border border-gray-300 p-2">₹ 8000</td>
              <td className="border border-gray-300 p-2">₹ 9000</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Industry person</td>
              <td className="border border-gray-300 p-2">₹ 10000</td>
              <td className="border border-gray-300 p-2">₹ 12000</td>
              <td className="border border-gray-300 p-2">₹ 12000</td>
              <td className="border border-gray-300 p-2">₹ 15000</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Accompanying person</td>
              <td className="border border-gray-300 p-2">₹ 3000</td>
              <td className="border border-gray-300 p-2">N/A</td>
              <td className="border border-gray-300 p-2">₹ 4000</td>
              <td className="border border-gray-300 p-2">N/A</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Students from outside India</td>
              <td className="border border-gray-300 p-2">$ 250</td>
              <td className="border border-gray-300 p-2">$ 300</td>
              <td className="border border-gray-300 p-2">$ 350</td>
              <td className="border border-gray-300 p-2">$ 400</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Faculty/Scientist from outside India</td>
              <td className="border border-gray-300 p-2">$ 400</td>
              <td className="border border-gray-300 p-2">$ 500</td>
              <td className="border border-gray-300 p-2">$ 500</td>
              <td className="border border-gray-300 p-2">$ 600</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="text-gray-600 mt-4">
        *<span className="italic">18% GST will be charged extra on the above mentioned fees.</span>
      </p>
    </div>
  );
};

export default RegistrationInfo;
